import { OrderKeys } from '~src/spacesPlatform/models/OrderKeys';
import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';

export const recycleBinSpaceDefaultSortOrder: IOrderClause[] = [Order.asc(OrderKeys.name)];

export const recycleBinSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'path': SortOptions.path,
  'owner': SortOptions.ownerId,
  'deleter': SortOptions.deleterUserId,
  'deletedAt': SortOptions.deleted
};